import classNames from "classnames";

export const EmbedContainer = ({
  className,
  isLoaded,
  children,
}: {
  className?: string;
  isLoaded: boolean;
  children: React.ReactNode;
}) => (
  <div
    className={classNames(
      className,
      !isLoaded && "bg-surface-primary-active animate-pulse",
    )}
  >
    {children}
  </div>
);
